<template>
  <div class="progress_bar" v-show="shown">
    <div class="progress_bar-line"
         :class="{line_shown: shown}"
         :style="{width: width + '%'}"
      >{{getProgressBarStatus}}</div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
const DEFAULT_INTERVAL = 150
const SPEED_INTERVAL = 60
export default {
  name: "ProgressBar",
  computed: {
    ...mapGetters([
      'getProgressBarStatus'
    ]),
  },
  data() {
    return {
      width: 0,
      shown: true,
      interval: true,
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.shown = true
      this.intervalFunction()
    },
    intervalFunction(interval = DEFAULT_INTERVAL) {
      this.interval = setInterval(() => {
        if (this.width >= 100) {
          clearInterval(this.interval)
          this.finish()
          return
        }
        this.width += 7
      }, interval)
    },
    finish() {
      setTimeout(() => {
        this.width = 0
        this.shown = false
      }, 0)
    }
  },
  watch: {
    'getProgressBarStatus'(val) {
      if (val) {
        clearInterval(this.interval)
        this.width = 0
        this.init()
      } else {
        clearInterval(this.interval)
        this.intervalFunction(SPEED_INTERVAL)
      }
    }
  }
}
</script>
